import React, { useState } from 'react';
import { useModalDismiss } from '../../../hooks/useModalDismiss';

interface ConfirmDeleteModalProps {
  count: number;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function ConfirmDeleteModal({ count, onClose, onConfirm }: ConfirmDeleteModalProps) {
  const [loading, setLoading] = useState(false);
  const dismiss = useModalDismiss(onClose);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="confirm-delete-modal-overlay" {...dismiss}>
      <div className="confirm-delete-modal">
        <div className="confirm-delete-icon">⚠️</div>
        <h3 className="confirm-delete-title">确认删除？</h3>
        <p className="confirm-delete-message">
          正在删除 <span className="confirm-delete-count">{count}</span> 部作品。<br/>此操作不可恢复。
        </p>
        <div className="confirm-delete-actions">
          <button onClick={onClose} className="confirm-delete-cancel-btn">取消</button>
          <button 
            onClick={handleConfirm}
            disabled={loading}
            className="confirm-delete-confirm-btn"
          >
            彻底删除
          </button>
        </div>
      </div>
    </div>
  );
}
